import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@nexelem/api';

export const ordersDetailsQueryKey = (orderIds: number[]) => ['orders-details', [...orderIds].sort().join(',')];

export const useOrdersDetails = (orderIds: number[]) => {
  const api = useAPI();

  return useQuery({
    queryKey: ordersDetailsQueryKey(orderIds),
    queryFn: async () => {
      if (!orderIds.length) {
        return [];
      }
      const promises = orderIds.map((id) => api.getBackOrdersViewId({ id }));
      return Promise.all(promises);
    },
    enabled: orderIds.length > 0,
  });
};
